import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "accordion-item" }
const _hoisted_2 = { class: "header-text fs-5" }
const _hoisted_3 = { class: "number" }
const _hoisted_4 = { class: "accordion-content mt-3 pb-4" }
const _hoisted_5 = {
  key: 0,
  class: "mx-auto bg-transparent mt-4 mb-0"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DBOptionsAccordionItem',
  props: {
        position: { type: Number, required: true },
        open: { type: Boolean, required: true },
        title: { type: String, required: true },
        isNotLastItem: { type: Boolean, required: true }
    },
  emits: ["toggle-accordion-item"],
  setup(__props) {

    const props = __props;

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "accordion-header",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-accordion-item')))
    }, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.position) + ". ", 1),
        _createTextVNode(_toDisplayString(__props.title), 1)
      ]),
      _createElementVNode("i", {
        class: _normalizeClass(`chevron-icon bi-chevron-down ${__props.open ? 'rotated' : ''}`)
      }, null, 2)
    ]),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ], 512), [
          [_vShow, __props.open]
        ])
      ]),
      _: 3
    }),
    (__props.isNotLastItem)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}
}

})